import { processingApi } from '@/api/processingApi'
import axios from '../axios'

function createUrl(id) {
  const url = new URL(`object-model/${id}`, window.appConfig.GraphQlUrl)
  return url
}

export default {
  install(Vue) {
    Vue.$objectModelRunner = Vue.prototype.$objectModelRunner = {
      async executeObjectModelQuery (id, parameters) {
        try {
          processingApi.show()
          const { data } = await axios.post(createUrl(id), parameters)
          return data
        } catch (e) {
          throw new Error(e.message)
        } finally {
          processingApi.hideAll()
        }
      }
    }
  }
}